import axios from 'axios';

// In production the backend serves the frontend, so a relative '/api' path
// works on the same origin. In development it points at the local API server.
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const API = axios.create({ baseURL: API_BASE_URL });

export const fetchTutors = (filters) => API.get('/tutors', { params: filters });
export const fetchTutorById = (id) => API.get(`/tutors/${id}`);

// Online Class API
export const fetchAllClasses   = (params)         => API.get('/classes', { params });
export const fetchMyClasses    = (teacherId)      => API.get(`/classes/teacher/${teacherId}`);
export const createClass       = (data)           => API.post('/classes', data);
export const updateClass       = (id, data)       => API.put(`/classes/${id}`, data);
export const deleteClass       = (id)             => API.delete(`/classes/${id}`);
export const getClassJoinInfo  = (id, token)      => API.get(`/classes/${id}/join`, { headers: { Authorization: `Bearer ${token}` } });

// Google account connection (teacher only) - powers auto-created Google
// Meet links for "Schedule New Class".
export const getGoogleAuthUrl  = (token) => API.get('/google/auth-url', { headers: { Authorization: `Bearer ${token}` } });
export const disconnectGoogle  = (token) => API.post('/google/disconnect', {}, { headers: { Authorization: `Bearer ${token}` } });
export const createTutor = (tutorData) => API.post('/tutors', tutorData);
export const updateTutor = (id, tutorData) => API.put(`/tutors/${id}`, tutorData);
export const deleteTutor = (id) => API.delete(`/tutors/${id}`);

export const fetchResources = (type, category, subject, extraParams = {}) =>
    API.get('/resources', { params: { type, category, subject, ...extraParams } });

export const createResource = (formData) => API.post('/resources', formData);
export const deleteResource  = (id)       => API.delete(`/resources/${id}`);
export const replaceResourceFile = (id, formData) => API.put(`/resources/${id}/file`, formData);
export const getResourceFileUrl = (id, download = false) =>
    `${API_BASE_URL.replace(/\/+$/, '')}/resources/${encodeURIComponent(id)}/file${download ? '?download=true' : ''}`;

// Ads API functions
export const fetchAds = () => API.get('/ads');

export const createAd = (adData) => API.post('/ads', adData);

export const updateAd = (id, adData) => API.put(`/ads/${id}`, adData);

export const deleteAd = (id) => API.delete(`/ads/${id}`);

// Blog API functions
export const fetchBlogs      = (params) => API.get('/blogs', { params });
export const fetchBlogById   = (id)     => API.get(`/blogs/${id}`);
export const createBlog      = (data)   => API.post('/blogs', data);
export const updateBlog      = (id, data) => API.put(`/blogs/${id}`, data);
export const deleteBlog      = (id)     => API.delete(`/blogs/${id}`);

// Student API functions
export const fetchStudents     = ()   => API.get('/auth/students');
export const fetchStudentById  = (id) => API.get(`/auth/students/${id}`);
export const deleteStudentById = (id) => API.delete(`/auth/students/${id}`);

// Product API functions
export const fetchProducts    = (params) => API.get('/products', { params });
export const fetchProductById = (id)     => API.get(`/products/${id}`);
export const createProduct  = (data)   => API.post('/products', data);
export const updateProduct  = (id, data) => API.put(`/products/${id}`, data);
export const deleteProduct  = (id)     => API.delete(`/products/${id}`);

// Subject API functions
export const fetchSubjects = () => API.get('/subjects');
export const createSubject = (subjectData) => API.post('/subjects', subjectData);
export const deleteSubject = (id) => API.delete(`/subjects/${id}`);
export const updateSubject = (id, subjectData) => API.put(`/subjects/${id}`, subjectData);
